import apiconfig from '../api-config';
const api_url = location.href.indexOf('https://entry.universal-field.com/rsapp/') == 0 ? apiconfig.api_url : apiconfig.stgapi_url;

const api_ver = 20220928;

async function getApi(cmd_url, param) {     // eslint-disable-line no-unused-vars
    const query_params = new URLSearchParams(param);
    const url = cmd_url+'&'+query_params+((query_params ? '&' : '') + 'ver='+api_ver);
    return await fetch(api_url+url, {
        "Content-Type": "application/json;charset=utf-8"
    }).then((res)=>{
        return( res.json() );
    });
}

async function postApi(cmd_url, inparam) {    // eslint-disable-line no-unused-vars
    const param = {
        ver: api_ver,
        ...inparam
    }
    return await fetch(api_url+cmd_url, {
        "method": "POST",
        "headers": {
            "Content-Type": "application/json; charset=utf-8"
        },
        "Content-Type": "application/json;charset=utf-8",
        "body": JSON.stringify(param)
    }).then((res)=>{
        return( res.json() );
    });
}

function checkApiError(response) {
    if(response && response.message) {
        return false;
    }
    return true;
}

class apiConnectorClass {
    async loginApi(param) {
        const cmd_url = '?action=login';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    async logoutApi(param) {
        const cmd_url = '?action=logout';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    async getAuthQrcodeApi(param) {
        const cmd_url = '?action=get_auth_qrcode';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    async userApi(param) {
        const cmd_url = '?action=user';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    async runstStatusApi(param) {
        const cmd_url = '?action=runst_status';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async applySubscription(param) {
        const cmd_url = '?action=apply_subscription_by_id';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async continueSubscription(param) {
        const cmd_url = '?action=continue_subscription_by_id';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async cancelSubscription(param) {
        const cmd_url = '?action=cancel_subscription';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    /* これらは不要になっています
    async batchSubscription(param) {
        const cmd_url = '?action=batch_subscription';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async searchBatchSubscription(param) {
        const cmd_url = '?action=search_batch_subscription';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    */

    // チケット購入
    async buyTicket(param) {
        const cmd_url = '?action=buy_ticket';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    // 月額ステータス
    async monthlyStatusApi(param) {
        const cmd_url = '?action=monthly_status';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    // ランステ受付を開始する
    async receptionRunst(param) {
        const cmd_url = '?action=reception_runst';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    
    // ランステ受付(チケット)を開始する
    async receptionRunstTicket(param) {
        const cmd_url = '?action=reception_runst_ticket';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    // ランステ受付をポーリングする
    async checkReceptionStatus(param){
        const cmd_url = '?action=check_reception_runst';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    
	// ランステ利用状況を取得する
    async runstLogApi(param){
        const cmd_url = '?action=runst_log';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

	// ランステチケット利用状況を取得する
    async ticketLogApi(param){
        const cmd_url = '?action=runst_ticket_log';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

	// ランステ月額会員利用状況を取得する
    async monthlyLogApi(param){
        const cmd_url = '?action=runst_monthly_log';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    // 予約状況取得
    async listupReservations(param) {
        const cmd_url = '?action=get_reservations';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async profileApi(param) {
        const cmd_url = '?action=profile';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }
    async ajaxZip(zipcode) {
        const urlZipAjax = 'https://entry.universal-field.com/zip_ajax.php';
        const url = urlZipAjax+'?zipcode='+zipcode;
        return await fetch(url, {
            "Content-Type": "application/json;charset=utf-8"
        }).then((res)=>{
            return( res.json() );
        });
    }
    
    async validateProfileApi(param) {
        const cmd_url = '?action=validate_profile';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async updateProfileApi(param) {
        const cmd_url = '?action=update_profile';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async pointInfoApi(param) {
        const cmd_url = '?action=point_info';
		const response = await getApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async lostPasswordApi(param) {
        const cmd_url = '?action=lost_password';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

    async getServiceToken(param) {
        const cmd_url = '?action=get_service_token';
		const response = await postApi(cmd_url, param);
		return checkApiError(response) ? response : null;
    }

}
export const apiConnector = new apiConnectorClass(null);
